var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHome = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3,11v2h1v8c0,0.5,0.4,1,1,1H19c0.5,0,1-0.4,1-1v-8h1v-2H3z M18,20h-3.5v-4H9.5v4H6v-7h12V20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7,3.6l-9.1,9.1c-0.4,0.4-1,0.4-1.4,0l-0.1-0.1c-0.4-0.4-0.4-1,0-1.4l9.1-9.1c0.4-0.4,1-0.4,1.4,0l0.1,0.1 C13,2.7,13,3.3,12.7,3.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3,3.6l9.1,9.1c0.4,0.4,1,0.4,1.4,0l0.1-0.1c0.4-0.4,0.4-1,0-1.4l-9.1-9.1c-0.4-0.4-1-0.4-1.4,0l-0.1,0.1 C10.9,2.7,10.9,3.3,11.3,3.6z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHome, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/home.64dcae2f.svg";
export { ForwardRef as ReactComponent };